import { useState } from 'react';
import { Box, Flex } from 'reflexbox';

import Toggle from 'packages/kakapo-ui-kit/components/forms/controls/Toggle';
import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';

import BulkModal from './BulkModal';
import BulkSSOIdentityProvider from './BulkSSOIdentityProvider';
import { IdentityProvider, User, useEnsureAssociatedIdentitiesMutation } from 'generated/graphql';

export default function BulkSingleSignOnModal(props: { users: User[]; onDismiss: () => void }) {
	const [ensure] = useEnsureAssociatedIdentitiesMutation();
	const [identityProvider, setIdentityProvider] = useState<IdentityProvider['id']>();

	const [enabled, setEnabled] = useState(false);

	return (
		<BulkModal
			name="bulkSingleSignOn"
			onDismiss={props.onDismiss}
			valid={Boolean(identityProvider)}
			users={props.users}
			apply={async (user) => {
				await ensure({
					variables: {
						input: {
							userID: user.id,
							identityProviderID: identityProvider!,
							names: enabled ? [user.username, user.email] : [],
						},
					},
				});
			}}
		>
			<Flex alignItems="center" mb={3}>
				<Box flexGrow={1}>
					<Box mb={2}>
						<SubSectionTitle>Single Sign-On</SubSectionTitle>
					</Box>
					<ParagraphSmall color="slateBlue">
						With Treams Single Sign-On, this employee can login directly through their company
						account.
					</ParagraphSmall>
				</Box>
				<Box ml={3} flexShrink={0} flexGrow={0}>
					<Toggle
						name="sso"
						checked={enabled}
						value=""
						onChange={() => {
							setEnabled(!enabled && !!identityProvider);
						}}
						unspaced
					/>
				</Box>
			</Flex>

			<BulkSSOIdentityProvider onChange={setIdentityProvider} />
		</BulkModal>
	);
}
